import {PewClientConfig} from '@bgl/lib-ts-integration';

export const init = () => {

    PewClientConfig.config.host = '/business_public_feesim';
    PewClientConfig.config.appName = import.meta.env.VITE_REACT_APP_NAME;
    PewClientConfig.config.appVersion = import.meta.env.VITE_REACT_APP_VERSION;
    PewClientConfig.config.componentId = import.meta.env.VITE_REACT_APP_COMPONENT_ID;

    PewClientConfig.config.bglLogger['local-enable'] = true;
    PewClientConfig.config.bglLogger['remote-enable'] = false; /* Disabled remote logging waiting fwk fix */

    PewClientConfig.config.bglMonitor['monitor-url'] = '/rest/v1/monitoring/client-event/post';
    PewClientConfig.config.bglMonitor['monitor-pool-url'] = '/rest/v1/monitoring/client-event-list/post';
    PewClientConfig.config.bglMonitor['monitor-pool-activated'] = false;
    PewClientConfig.config.bglMonitor['pool-size'] = 5;

    PewClientConfig.config.bglMonitor['monitor-activated'] = false; /* Disabled remote logging waiting fwk fix */

};
